import { useCallback, useEffect, useRef } from 'react';
import toast from 'react-hot-toast';

const useStreamingChat = ({
  store,
  selectedChat,
  chatId,
  axiosSource,
  setAxiosSource,
  updateStreamingMessages,
  loading,
  addContentStop,
  userMessage,
  setCancel,
}) => {
  const stopped = useRef(false);

  // on Stop message
  const onStop = () => {
    store.stopStreamChat(
      selectedChat?.chat._id ? selectedChat?.chat._id : chatId.current
    );
    axiosSource.cancel();
    addContentStop();
    stopped.current = true;
  };

  // Event handler for streaming messages
  const eventHandler = useCallback(
    (event) => {
      updateStreamingMessages(event, loading);
    },
    [loading]
  );

  // Listen for streaming messages of chat
  useEffect(() => {
    store.listenEvent('writing', eventHandler);
    return () => {
      store.removeListener('writing', eventHandler);
    };
  }, [eventHandler]);

  // cancel chat
  const cancelChat = () => {
    if (!stopped.current && userMessage && userMessage.current) {
      toast('Switching windows interrupts response', {
        icon: '📢',
      });
    }
    if (axiosSource) {
      setCancel(true);
      userMessage.current = null;
      axiosSource.cancel();
      setAxiosSource(null);
    }
  };

  return {
    stopped,
    onStop,
    cancelChat,
  };
};

export default useStreamingChat;
